// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__1VKNK","close":"Buttons_close__q3hR0","error":"Buttons_error__nrvMJ"};